import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IChangeUsersRoleRequest } from '../models'

export class ChangeUsersRoleApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/userPermission/ChangeUsersRole',
      requesterInfo,
    })
  }

  public async changeUsersRole(request: IChangeUsersRoleRequest): Promise<boolean> {
    return await this.postAsync<boolean>(request)
  }
}
